/* global UMainHeader, UProgram */
class UBody extends Uneet {
  constructor(domElement) {
    super(domElement)
    this.accordions = []
    this.expands = []
    this.__init()
  }

  __init() {
    this._e.addClass('isLoaded')

    const headerDOM = this._e.querySelector('header.u_main-header')
    if (headerDOM) {
      this.mainHeader = new UMainHeader(headerDOM)
    }

    const programDOM = this._e.querySelector('.u_program')
    if (programDOM) {
      this.program = new UProgram(programDOM)
    }


    this.accordions = this.createChildUneets('u_accordion')

    this.expands = this.createChildUneets('u_expand')
  }
}

window.addEventListener('load', () => {
  const body = document.querySelector('body.u_body')
  if (body !== undefined) {
    const bodyUneet = new UBody(body)
  }
})
